import React from 'react';
import { useHistory } from 'react-router-dom';
import Container from '@mui/material/Container';
import { NotFoundUi } from 'te-components';

const NotFound = () => {
  const history = useHistory();
  const handleGoBack = () => history.goBack();

  return (
    <Container>
      <NotFoundUi handleLinkClick={handleGoBack} />
    </Container>
  );
};

export default NotFound;
